import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper, useMediaQuery } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SectionContainer from '../ui/SectionContainer';
import theme from '../../theme/theme';

/**
 * InitialPrompt - 初期状態の誘導表示コンポーネント
 */
function InitialPrompt({ action, location, variant }) {
    const isMobile = useMediaQuery('(max-width:768px)');
    
    const needsAction = !action;
    
    // variant に応じたテーマカラー
    const borderColor = variant === 'purpose' 
        ? 'rgba(74, 85, 104, 0.2)' 
        : 'rgba(85, 60, 154, 0.2)';
    
    const backgroundColor = variant === 'purpose'
        ? 'rgba(248, 249, 250, 0.98)'
        : 'rgba(250, 248, 255, 0.98)';
    
    const promptColor = needsAction 
        ? (variant === 'purpose' ? theme.palette.primary.main : theme.palette.secondary.main)
        : theme.palette.success.main;
    
    const promptText = needsAction
        ? (variant === 'purpose' ? '「やりたいこと」を選んでください' : '「見たいグラフ」を選んでください')
        : '「計測場所」を選んでください';
    
    return (
        <SectionContainer>
            <Paper 
                elevation={1} 
                sx={{ 
                    borderRadius: '12px',
                    border: `2px solid ${borderColor}`,
                    backgroundColor: backgroundColor,
                    p: isMobile ? 2 : 3,
                    position: 'relative',
                    zIndex: 1002
                }}
            >
                <Box sx={{ textAlign: 'center' }}>
                    <ArrowUpwardIcon 
                        sx={{ 
                            fontSize: isMobile ? '1.5rem' : '2rem',
                            color: promptColor,
                            mb: 1,
                            animation: 'pulse 2s infinite'
                        }} 
                    />
                    <Typography 
                        variant="h6" 
                        sx={{ 
                            fontWeight: 600,
                            color: promptColor,
                            mb: 1,
                            fontSize: isMobile ? '1rem' : '1.1rem'
                        }}
                    >
                        {promptText}
                    </Typography>
                </Box>
            </Paper>
            
            {/* アニメーションのCSS */}
            <style>
                {`
                    @keyframes pulse {
                        0%, 100% {
                            transform: scale(1);
                            opacity: 1;
                        }
                        50% {
                            transform: scale(1.1);
                            opacity: 0.8;
                        }
                    }
                `}
            </style>
        </SectionContainer>
    );
}

InitialPrompt.propTypes = {
    action: PropTypes.string,
    location: PropTypes.string,
    variant: PropTypes.oneOf(['purpose', 'function']).isRequired,
};

export default InitialPrompt;
